import { useProductKeys } from ".";

export type TipsViewType = "default" | "jira-bundle" | "jira-only-bundle";

export function useTipsViewType() {
    const productKeys = useProductKeys();
    const { length: jiraProductsCount } = productKeys.filter((product) =>
        product.includes("jira")
    );
    const nonJiraProductsCount = productKeys.length - jiraProductsCount;
    if (jiraProductsCount >= 2 && nonJiraProductsCount > 0) {
        return "jira_bundle";
    } else if (jiraProductsCount >= 2 && nonJiraProductsCount === 0) {
        return "jira_only_bundle";
    } else {
        return "default";
    }
}
